'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Star = function (_React$Component) {
  (0, _inherits3.default)(Star, _React$Component);

  function Star(props) {
    (0, _classCallCheck3.default)(this, Star);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Star.__proto__ || (0, _getPrototypeOf2.default)(Star)).call(this, props));

    _this.state = {
      starred: _this.props.starred
    };
    return _this;
  }

  (0, _createClass3.default)(Star, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      var starred = !this.state.starred;

      this.setState({ starred: starred });
      this.props.onClick(starred);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Star.scss');
      var starred = this.state.starred;

      var classes = "fa fa-star-o";

      if (starred === true) classes = "fa fa-star";

      return _react2.default.createElement(
        'div',
        { onClick: this.handleClick.bind(this) },
        _react2.default.createElement('i', { className: classes })
      );
    }
  }]);
  return Star;
}(_react2.default.Component);

exports.default = Star;


Star.defaultProps = {
  starred: false
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Star/Star.jsx
// module id = 2698
// module chunks = 0